// extracted by mini-css-extract-plugin
export var label = "_k7-2";
export var slideContainer = "_k7-0";
export var slider = "_k7-1";